import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './Erro.scss';

function Erro(props) {
	let strErro;

	switch (props.params.idErro) {
		case '401':
			strErro = 'Acesso não autorizado';
			break;
		case '403':
			strErro = 'Área restrita';
			break;
		case '404':
			strErro = 'Página não encontrada ou sessão expirada';
			break;
		default:
			strErro = '';
			break;
	}

	return (
		<div className='boxPaginaErro'>
			<div className="imgErro" />
			<a  
				// href="http://gnre.econeteditora.com.br"
				href="http://www.econeteditora.com.br"
			>
				Erro {props.params.idErro}
				{strErro && ` (${strErro})`}: <br />
				Clique aqui para ir a página inicial
			</a>			
		</div>
	);
}

Erro.propTypes = {
	params: PropTypes.object.isRequired,
};

export default withRouter(Erro);
